(()=>{
  const boot=()=>{
    const preview=document.querySelector('[data-hfd] .hfd__scene.is-active [data-preview]')||document.querySelector('[data-hfd] [data-preview]');
    const hosts=[...document.querySelectorAll('[data-story-design]')].filter(host=>!host.closest('[data-hfd-product]'));
    if(!preview||!hosts.length)return;

    let raf=0;
    let lastKey='';
    const isLivePan=event=>{
      if(document.querySelector('[data-hfd] .is-panning'))return true;
      return event?.type==='flag:image-adjust-state'&&!event.detail?.print;
    };
    const sync=()=>{
      raf=0;
      const width=preview.clientWidth;
      const height=preview.clientHeight;
      const markup=preview.innerHTML;
      if(!markup||!width||!height)return;
      const key=hosts.map(host=>`${host.clientWidth}x${host.clientHeight}`).join('|')+`:${width}x${height}:${markup}`;
      if(key===lastKey)return;
      lastKey=key;

      hosts.forEach(host=>{
        const frame=document.createElement('span');
        const scale=Math.min(host.clientWidth/width,host.clientHeight/height);
        frame.className='homepage-story__rendered-design';
        frame.style.width=`${width}px`;
        frame.style.height=`${height}px`;
        frame.style.left=`${(host.clientWidth-width*scale)/2}px`;
        frame.style.top=`${(host.clientHeight-height*scale)/2}px`;
        frame.style.transform=`scale(${scale})`;
        frame.innerHTML=markup;
        frame.querySelectorAll('[data-preview]').forEach(element=>element.removeAttribute('data-preview'));
        host.replaceChildren(frame);
      });
    };

    const schedule=event=>{
      if(isLivePan(event))return;
      if(raf)cancelAnimationFrame(raf);
      raf=requestAnimationFrame(sync);
    };

    new MutationObserver(()=>schedule()).observe(preview,{subtree:true,childList:true});
    const resizeObserver=new ResizeObserver(()=>schedule());
    resizeObserver.observe(preview);
    hosts.forEach(host=>resizeObserver.observe(host));

    ['flag:design-change','flag:upload-state','flag:focus-state','flag:image-adjust-state','flag:library-rendered'].forEach(name=>{
      document.addEventListener(name,schedule);
    });

    sync();
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
